<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="注册模板" :visible.sync="dialogFormVisible" width="60%" top="3vh">
      <el-form :inline="true" class="demo-form-inline" style="padding:0;">
        <el-form-item label="模板号">
          <el-input v-model="template_no" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="模板名称">
          <el-input v-model="template_name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <h3 style="margin:0;padding:0;">模板详情</h3>
      <!-- {{ JSON.stringify(form_list) }} -->
      <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:160px">
        <el-form label-width="80px" class="demo-ruleForm">
          <div class="demo-rulrForm-item">
            <div v-for="(item, index) in form_list" :key="index">
              <el-form-item :label="item.label" v-if="index <= form_list.length / 3">
                <el-input v-model="design[item.value]" autocomplete="off"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="demo-rulrForm-item">
            <div v-for="(item, index) in form_list" :key="index">
              <el-form-item :label="item.label" v-if="
                index <= (form_list.length * 2) / 3 &&
                index > form_list.length / 3
              ">
                <el-input v-model="design[item.value]" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div style="width:100%">
              <el-form-item label="单位" style="width:100%">
                <el-switch disabled v-model="unit" active-text="px" inactive-text="mm">
                </el-switch>
              </el-form-item>
            </div>
          </div>
          <div class="demo-rulrForm-item">
            <div v-for="(item, index) in form_list" :key="index">
              <el-form-item :label="item.label" v-if="index > (form_list.length * 2) / 3">
                <el-input v-model="design[item.value]" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div>
              <!-- TODO: 选择打印机 -->
              <el-form-item label="打印机">
                <el-select :clearable="true" @change="printerChange" style="width:150px;" v-model="design.printer.name"
                  placeholder="请选择打印机">
                  <el-option v-for="item in printerList" :key="item.printer" :label="item.printer"
                    :value="item.printer">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="打印机">
                <el-input
                  v-model="design.printer"
                  autocomplete="off"
                ></el-input>
              </el-form-item> -->
            </div>
          </div>
        </el-form>
      </el-scrollbar>
      <h3 style="padding:0;margin: 10px 0;">标签详情</h3>
      <div class="demo-ruleForm">
        <div @click="modifyChecked(key)" class="demo-ruleForm-clumn"
          :class="key == clickedClumn ? 'demo-ruleForm-clumn-clicked' : ''" v-for="(item, key, index) in design.content"
          :key="index">
          {{ item.other3 }}
        </div>
      </div>
      <el-scrollbar v-if="clickedClumn" wrapStyle="overflow-x:hidden;" style="height:210px">
        <el-form label-width="120px" class="demo-ruleForm">
          <div class="demo-rulrForm-item">
            <div v-for="(item, index) in contentItem_list" :key="index">
              <el-form-item :label="item.label" v-if="index <= contentItem_list.length / 2">
                <el-input v-model="design.content[clickedClumn][item.value]" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <div v-if="clickedClumn != 'uparrow' && clickedClumn != 'downarrow'">
              <el-form-item label="字体样式">
                <el-select style="width:150px;" v-model="design.content[clickedClumn].fontStyle" placeholder="字体样式">
                  <el-option v-for="item in styleList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="clickedClumn == 'barcode'">
              <el-form-item label="窄比">
                <el-input v-model="design.content.barcode.barcode.narrow" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="宽比">
                <el-input v-model="design.content.barcode.barcode.wide" autocomplete="off"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="demo-rulrForm-item">
            <div v-for="(item, index) in contentItem_list" :key="index">
              <el-form-item :label="item.label" v-if="index > contentItem_list.length / 2">
                <el-input v-model="design.content[clickedClumn][item.value]" autocomplete="off"></el-input>
              </el-form-item>
            </div>
            <!-- {{ design.content[clickedClumn].underline }} -->
            <el-form-item v-if="design.content[clickedClumn].other1 == 'i-text'" label="文本内容">
              <el-input v-model="design.content[clickedClumn].other3" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item v-if="clickedClumn != 'uparrow' && clickedClumn != 'downarrow'" label="下划线">
              <div style="width: 220px;height: 40px;display:flex;align-items: center;">
                <el-radio v-model="design.content[clickedClumn].underline" :label="true">显示下划线</el-radio><el-radio
                  v-model="design.content[clickedClumn].underline" :label="false">隐藏</el-radio>
              </div>
            </el-form-item>

            <el-form-item v-if="clickedClumn != 'uparrow' && clickedClumn != 'downarrow'" label="删除线">
              <div style="width: 220px;height: 40px;display:flex;align-items: center;">
                <el-radio v-model="design.content[clickedClumn].linethrough" :label="true">显示删除线</el-radio>
                <el-radio v-model="design.content[clickedClumn].linethrough" :label="false">隐藏</el-radio>
              </div>
            </el-form-item>
            <div v-if="clickedClumn == 'barcode'">
              <el-form-item label="条码类型">
                <el-input v-model="design.content.barcode.barcode.type" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="字符可见">
                <div style="width: 220px;height: 40px;display:flex;align-items: center;">
                  <el-radio v-model="design.content.barcode.barcode.readable" :label="true">字符可见</el-radio>
                  <el-radio v-model="design.content.barcode.barcode.readable" :label="false">字符不可见</el-radio>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </el-scrollbar>

      <div slot="footer" class="" style="padding:10px;margin: 0px;">
        <el-button type="success" @click="exportTemplate">导出为文本</el-button>
        <el-button @click="hideDialog">取 消</el-button>
        <el-button v-if="modify" type="primary" @click="printModify">保存修改</el-button>
        <el-button v-else type="primary" @click="printRegister">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportTXT } from "@/js/docx.js";
import {
  printRegister,
  printModify,
  offlinestoresMessage
} from "@/api/merchant.js";
import { mapMutations } from "vuex";
export default {
  name: "dyh-createtemp",
  data() {
    return {
      dialogFormVisible: false,
      template_no: "",
      template_name: "",
      /**
       * @type {string} clickedClumn 选中的标签选项
       */
      clickedClumn: "",
      design: {
        page_height: 0,
        page_width: 0,
        paper: "",
        row_gap: 0,
        column_gap: 0,
        columns: 0,
        black_height: 0,
        left: 0,
        top: 0,
        speed: 0,
        density: 0,
        direction: "",
        printer: {
          name: "",
          url: ""
        },
        content: {}
      },
      form_list: [], // 模板的长宽高属性 width、 height
      contentItem_list: [], //每一项的长宽高属性  in_price 的长宽高
      modify: false,
      printerList: [], //打印机列表
      styleList: [
        { value: 0, label: "标准 " },
        { value: 1, label: "斜体 " },
        { value: 2, label: "粗体 " },
        { value: 3, label: "粗斜体" }
      ]
    };
  },
  /* watch:{
    dialogFormVisible(newdia,olddia){
      if(!newdia){

      }
    }
  }, */
  computed: {
    /* unit() {
      return this.$store.state.canvas.unit;
    }, */
    unit: {
      get() {
        return this.$store.state.canvas.unit === "px";
      },
      set(value) {
        this.CHANGECOMPUTE(value);
      }
    }
  },
  mounted() {
    this.printerList = [];
    offlinestoresMessage().then(res => {
      if (this.testR(res)) {
        if (res.data && res.data.resp_data) {
          this.printerList = res.data.resp_data;
        }
      }
    });
  },
  methods: {
    ...mapMutations("canvas", ["CHANGECOMPUTE"]),
    exportTemplate() {
      var design = this.computeSubmit({
        ...this.design
      });
      design.unit = this.$store.state.canvas.unit;
      if (this.unit) {
        //px 设置比例
        design.unit_scale = 100;
      } else {
        design.unit_scale = 1;
      }
      var data = {
        template_no: this.template_no,
        template_name: this.template_name,
        design: { ...design, unit: this.$store.state.canvas.unit }
      };
      data.page_height = Number(data.design.page_height);
      data.page_width = Number(data.design.page_width);
      data.design.printer = {
        name: "",
        url: ""
      };
      exportTXT(JSON.stringify(data), this.template_name);
    },
    printerChange(e) {
      /* for(let i=0;i<this.printerList.length;i++){
        if(e==this.printerList[i].printer){}} */
      if (this.printerList[0].url) {
        this.design.printer.url = this.printerList[0].url;
      }
    },
    /**
     *
     * @param {Object} obj 每次选中的标签的属性
     */
    getList(obj) {
      let list = [];
      if (obj.other1 === "image") {
        for (let key in obj) {
          switch (key) {
            case "left":
              list.push({
                label: "左边距",
                value: "left"
              });
              break;
            case "top":
              list.push({
                label: "上边距",
                value: "top"
              });
              break;
            case "width":
              list.push({
                label: "标签宽度",
                value: "width"
              });
              break;
            case "height":
              list.push({
                label: "标签高度",
                value: "height"
              });
              break;
          }
        }
        return list;
      }

      for (let key in obj) {
        switch (key) {
          case "page_height":
            list.push({
              label: "纸张高度",
              value: "page_height"
            });
            break;
          case "page_width":
            list.push({
              label: "纸张宽度",
              value: "page_width"
            });
            break;
          case "paper":
            list.push({
              label: "纸张类型",
              value: "paper"
            });
            break;
          case "direction":
            list.push({
              label: "打印方向",
              value: "direction"
            });
            break;
          case "row_gap":
            list.push({
              label: "行间距",
              value: "row_gap"
            });
            break;
          case "column_gap":
            list.push({
              label: "列间距",
              value: "column_gap"
            });
            break;
          case "columns":
            list.push({
              label: "列数量",
              value: "columns"
            });
            break;
          case "black_height":
            list.push({
              label: "黑标高度",
              value: "black_height"
            });
            break;
          case "left":
            list.push({
              label: "左边距",
              value: "left"
            });
            break;
          case "top":
            list.push({
              label: "上边距",
              value: "top"
            });
            break;
          case "speed":
            list.push({
              label: "打印速度",
              value: "speed"
            });
            break;
          case "density":
            list.push({
              label: "打印浓度",
              value: "density"
            });
            break;
          /* case "left":
          result.objects[key].left
          list.push({
              label:"",
              value:""
            })
             break;
          case "top":
             result.objects[key].top
             list.push({
              label:"",
              value:""
             })
             break; */
          case "width":
            list.push({
              label: "标签宽度",
              value: "width"
            });
            break;
          case "height":
            list.push({
              label: "标签高度",
              value: "height"
            });
            break;
          case "font_family":
            list.push({
              label: "字体样式",
              value: "font_family"
            });
            break;
          case "font_size":
            list.push({
              label: "字体大小",
              value: "font_size"
            });
            break;
          /* case "underline":
            list.push({
              label: "下划线",
              value: "underline"
            });
            break;
          case "linethrough":
            list.push({
              label: "删除线",
              value: "linethrough"
            });
            break; */
          case "textAlign":
            list.push({
              label: "字体对齐方式",
              value: "textAlign"
            });
            break;
          case "fontStyle":
            list.push({
              label: "字体风格",
              value: "fontStyle"
            });
            break;
        }
      }
      return list;
    },
    /**
     * @param {Object} json 标签的所有元素
     * @param {Boolean} modify 是否是修改模板
     * @param {Object} tempinfo 模板信息
     * @param {Object} barcodeBarcode 条码打印格式
     *
     */
    showDialog(json, modify, tempinfo, barcodeBarcode) {
      if (tempinfo) {
        this.template_no = tempinfo.template_no;
        this.template_name = tempinfo.template_name;

        this.design = { ...tempinfo.design };
        this.design.printer = tempinfo.design.printer
          ? tempinfo.design.printer
          : "TSC-244";
      }
      this.design.content = {};
      if (modify) {
        this.modify = true;
      }
      this.dialogFormVisible = true; //显示模态框
      /**
       * 模板的长宽高等属性
       */
      this.form_list = this.getList(this.design);

      //mm的时候 将长宽高等除以五
      if (!this.unit) {
        //'mm'
        this.design.page_height = Math.trunc(Number(json[0].height) / 5);
        this.design.page_width = Math.trunc(Number(json[0].width) / 5);
      } else {
        this.design.page_height = Math.trunc(Number(json[0].height));
        this.design.page_width = Math.trunc(Number(json[0].width));
      }

      if (tempinfo) {
        this.design.left = Number(tempinfo.design.left);
        this.design.top = Number(tempinfo.design.top);
      } else {
        this.design.left = 0;
        this.design.top = 0;
      }
      for (let i = 0; i < json.length; i++) {
        if (this.unit) {
          //px 设置比例
          json[i].unit_scale = 100;
        } else {
          json[i].unit_scale = 1;
        }
        if (
          (json[i].other1 === "textbox" || json[i].other1 === "i-text") &&
          json[i].other4 !== "barcode"
        ) {
          json[i].data_type = "txt";
        } else if (json[i].other1 === "image") {
          json[i].data_type = "img";
        } else if (json[i].other4 === "barcode") {
          json[i].data_type = "barcode";
        }
        /**
         * 某一项属性的属性
         * in_price 的长宽高等
         */
        if (
          (i === 1 && json[i].other1 === "textbox") ||
          json[i].other1 === "i-text" ||
          json[i].other1 === "image"
        ) {
          this.clickedClumn = json[1].other4;
          this.contentItem_list = this.getList(json[1]);
        }

        if (json[i].height) {
          json[i].height = Math.trunc(Number(json[i].height));
          if (!this.unit) {
            json[i].height = Math.trunc(Number(json[i].height) / 5);
          }

          if (json[i].other1 === "image") {
            //json[i].height = json[i].height;
          }
        }
        if (json[i].width) {
          json[i].width = Math.trunc(Number(json[i].width));
          if (!this.unit) {
            json[i].width = Math.trunc(Number(json[i].width) / 5);
          }
          if (json[i].other1 === "image") {
            //json[i].width = json[i].width;
          }
        }
        if (json[i].top) {
          json[i].top = Math.trunc(Number(json[i].top));
          if (!this.unit) {
            json[i].top = Math.trunc(Number(json[i].top) / 5);
          }
        }
        if (json[i].left) {
          json[i].left = Math.trunc(Number(json[i].left));
          if (!this.unit) {
            json[i].left = Math.trunc(Number(json[i].left) / 5);
          }
        }
        if (json[i].other4 === "barcode") {
          json[i].barcode = {
            type: "EAN13",
            narrow: 0,
            wide: 0,
            readable: true
          };
          if (barcodeBarcode.type) {
            json[i].barcode = barcodeBarcode;
          }
        }
        json[i].box = "";
        this.$set(this.design.content, json[i].other4, json[i]);
      }
      /* if (this.design.paper == "") {
        this.design.paper = "黑标";
      }
      if (this.design.direction == "") {
        this.design.direction = 1;
      } */
    },
    //隐藏model
    hideDialog() {
      this.dialogFormVisible = false;
      this.modify = false;
    },
    modifyChecked(key) {
      this.clickedClumn = key;
      this.contentItem_list = this.getList(this.design.content[key]);
    },
    printRegister() {
      var design = this.computeSubmit({
        ...this.design
      });
      design.unit = this.$store.state.canvas.unit;
      if (this.unit) {
        //px 设置比例
        design.unit_scale = 100;
      } else {
        design.unit_scale = 1;
      }
      printRegister(
        {
          template_no: this.template_no,
          template_name: this.template_name
        },
        design
      )
        .then(res => {
          if (this.testR(res)) {
            if (
              res.data.result_code === "SUCCESS" &&
              res.data.return_code === "SUCCESS" &&
              res.data &&
              res.data.resp_data.state === "SUCCESS"
            ) {
              this.successMessage(
                `${res.data.resp_data.template_name}注册成功！`
              );

              this.$emit("printRegister", true);
              this.$emit("modifyRegister", this.template_no);
            }
          }
        })
        .catch(err => {
          this.warnMessage(JSON.stringify(err));
        });
      this.dialogFormVisible = false;
      this.modify = false;
    },
    printModify() {
      var design = this.computeSubmit({
        ...this.design
      });
      design.unit = this.$store.state.canvas.unit;
      if (this.unit) {
        //px 设置比例
        design.unit_scale = 100;
      } else {
        design.unit_scale = 1;
      }
      printModify(
        {
          template_no: this.template_no,
          template_name: this.template_name
        },
        design
      )
        .then(res => {
          if (this.testR(res)) {
            if (
              res.data.result_code === "SUCCESS" &&
              res.data.return_code === "SUCCESS" &&
              res.data &&
              res.data.resp_data.state === "SUCCESS"
            ) {
              this.successMessage(
                `${res.data.resp_data.template_name}修改成功！`
              );
              this.$emit("modifyRegister", this.template_no);
            }
          }
        })
        .catch(err => {
          this.warnMessage(JSON.stringify(err));
        });
      this.dialogFormVisible = false;
      this.modify = false;
    },
    computeSubmit(datas) {
      const unit = this.$store.state.canvas.unit;
      var data = { ...datas };
      for (let key in data) {
        if (typeof data[key] === "object") {
          data[key] = this.computeSubmit(data[key]);
        } else {
          if (
            key === "height" ||
            key === "page_height" ||
            key === "top" ||
            key === "width" ||
            key === "page_width" ||
            key === "left"
          ) {
            //TODO: 9-11修改
            if (unit === "px") {
              data[key] = Math.trunc(Number(data[key]) * 20);
            }
          }
        }
      }
      return data;
    }
  }
};
</script>

<style lang="less" scoped>
.el-dialog {
  margin: 0 auto 10px !important;
}

/deep/.el-dialog__footer {
  padding: 0px !important;
}

.demo-ruleForm {
  display: flex;
  justify-content: left;
  padding: 0;

  .demo-rulrForm-item {
    width: 50%;

    .el-input {
      width: 150px;
    }
  }

  .demo-ruleForm-clumn {
    height: auto;
    background-color: #fff;
    color: #409eff;
    padding: 10px 10px 2px 10px;
    cursor: pointer;
  }

  .demo-ruleForm-clumn-clicked {
    background-color: #409eff;
    color: #fff;
  }
}
</style>
